import React, { Suspense, lazy, useState, useEffect } from 'react'
import 'react-toastify/dist/ReactToastify.css'
import { ToastContainer } from 'react-toastify'
import { Footer } from './components/Footer/Footer'
import { Header } from './components/Header/Header'
import { Main } from './components/Main/Main'
import { GlobalStyle } from './styles/global'
import { ScrollProgress } from './components/ScrollProgress/ScrollProgress'
import { Background } from './components/Background/Background'
import { Preloader } from './components/Preloader/Preloader'
import { ScrollToTop } from './components/ScrollToTop/ScrollToTop'
import { SpeedInsights } from "@vercel/speed-insights/react"

// Lazy-load interaction-only components so they don't block initial render
const MouseFollower = lazy(() =>
  import('./components/MouseFollower/MouseFollower').then(m => ({ default: m.MouseFollower }))
);
const Chatbot = lazy(() =>
  import('./components/Chatbot/Chatbot').then(module => ({ default: module.Chatbot }))
);

function App() {
  const [showMouseFollower, setShowMouseFollower] = useState(false);
  const [showChatbot, setShowChatbot] = useState(false);

  useEffect(() => {
    // MouseFollower: mount on desktop screens (> 768px)
    if (typeof window !== 'undefined' && window.innerWidth > 768) {
      setShowMouseFollower(true);
    }
  }, []);

  useEffect(() => {
    const loadChatbot = () => {
      setShowChatbot(true);
      cleanup();
    };

    const cleanup = () => {
      window.removeEventListener('scroll', loadChatbot);
      window.removeEventListener('mousemove', loadChatbot);
      window.removeEventListener('touchstart', loadChatbot);
    };

    window.addEventListener('scroll', loadChatbot, { passive: true });
    window.addEventListener('mousemove', loadChatbot, { passive: true });
    window.addEventListener('touchstart', loadChatbot, { passive: true });

    // Fallback timer to load chatbot after 4s
    const timer = setTimeout(loadChatbot, 4000);

    return () => {
      cleanup();
      clearTimeout(timer);
    };
  }, []);

  return (
    <>
      <GlobalStyle />
      <Preloader />
      <Background />
      <ScrollProgress />
      {showMouseFollower && (
        <Suspense fallback={null}>
          <MouseFollower />
        </Suspense>
      )}
        <Header />
        <Main />
        {showChatbot && (
          <Suspense fallback={null}>
            <Chatbot />
          </Suspense>
        )}
        <Footer />
        <ScrollToTop />
      <ToastContainer />
      {window.location.hostname.includes('vercel') && <SpeedInsights />}
    </>
  )
}

export default App
